import {Injectable} from '@angular/core';
import {IDocMergeAllowedEntitiesService} from './IDocMergeAllowedEntitiesService';

@Injectable({
  providedIn: 'root',
})
export class BullhornDocMergeAllowedEntitiesService implements IDocMergeAllowedEntitiesService {
  getAllowedEntities(): string[] {
    return ['Candidate', 'JobOrder', 'JobSubmission', 'Placement'];
  }
}
